<template>
  <VView class="contest-question" :header="$t('contestQuestion.header')">
    <VForm ref="form"
      :fields="fields"
      @update="onFormUpdate($event)"
    />

    <VBlock max-width="300px">
      <transition name="bounceUp" appear>
        <VButton @click="next()">{{ $t('contestQuestion.next') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
import { mapState } from 'vuex';
import { SET_ANSWER } from '@/store';
import {
  FIELD_TYPE_TEXTAREA,
  FIELD_TYPE_COMMENT,
} from '@/components/VForm.vue';

export default {
  name: 'ContestQuestion',

  computed: {
    ...mapState({
      fields(state) {
        return [
          {
            key: 'question',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestQuestion.question'),
            width: '100%',
          },
          {
            key: 'answer',
            type: FIELD_TYPE_TEXTAREA,
            isRequired: true,
            label: this.$t('contestQuestion.answer'),
            value: state.answer,
            width: '100%',
          },
          {
            key: 'required',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestQuestion.required'),
            width: '100%',
          },
        ];
      },
    }),
  },

  methods: {
    onFormUpdate({ value: answer }) {
      this.$store.commit(SET_ANSWER, { answer });
    },

    async next() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        return;
      }

      this.$router.push('/contest/personal');
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-question {}
</style>
